/** Preview size on the Kanban accordion (full list lives on the optimizer page). */
export const OPTIMIZER_KANBAN_PREVIEW_LIMIT = 5;

/** Default page size on the dedicated optimizer page. */
export const OPTIMIZER_PAGE_SIZE = 10;

export const WORK_ORDER_OPTIMIZER_PATH = '/maintenance/work-orders/optimizer';

export const WORK_ORDER_KANBAN_PATH = '/maintenance/work-orders/kanban';

export const OPTIMIZER_ACCORDION_SECTION_ID =
  'work-order-optimizer-suggestions';

/** Expanded panel body — target after “View suggestions” so details are on screen. */
export const OPTIMIZER_ACCORDION_CONTENT_ID =
  'work-order-optimizer-suggestions-content';
